import { useCallback } from 'react';

import { useTrackPromotionShare } from '#src/app/shared/hooks/promotion';

import { usePromotedTrackingDataWithQueryParams } from '../usePromotedTrackingDataWithQueryParams';

export function useOnPetitionShareSuccess(): () => void {
	const promotedTrackingData = usePromotedTrackingDataWithQueryParams();
	const trackPromotionShare = useTrackPromotionShare();

	return useCallback(() => {
		if (promotedTrackingData) {
			try {
				void trackPromotionShare(promotedTrackingData);
			} catch (e) {
				// do nothing
			}
		}
	}, [promotedTrackingData, trackPromotionShare]);
}
